{
  "version": 1,
  "asset_id": "5090cf2c-2b17-4b39-9a7f-429853517dc0",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/5090cf2c-2b17-4b39-9a7f-429853517dc0/g14.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/5090cf2c-2b17-4b39-9a7f-429853517dc0/g14.jpg",
  "original_filename": "g14.jpg",
  "size": 54885,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
